// extracted by mini-css-extract-plugin
export default {"no_loading":"main_no_loading__+KDsM","no_loading_view":"main_no_loading_view__2fowp","loading_loader":"main_loading_loader__RfbkU","spin":"main_spin__Qmsbc"};